export default "__VITE_ASSET__CUohWfxR__"